/*****************************************************************
 * TAG MIGRATION FILE
 * This file is meant to be removed once the migration from APIGEE to TAG is completed, so we can consume directly the variables from src/app/core/api/proxies/common-TAG-api-endpoints.ts and delete src/app/core/api/proxies/common-APIGEE-api-endpoints.ts and this file
 *****************************************************************/
import { ConfigLoader } from '@root/config-loader';
import { API_MAP as TagApiMap } from './common-TAG-api-endpoints';
import { API_MAP as ApigeeApiMap } from './common-APIGEE-api-endpoints';

const configLoader = new ConfigLoader();
function isTagProxyEnabled(): boolean {
  const config = configLoader.getConfig('featureToggleConfig');
  return !!(config && config.features && config.features['FEATURE.TAG_PROXY'] && config.features['FEATURE.TAG_PROXY'].enabled);
}

type ApiMapType = typeof TagApiMap | typeof ApigeeApiMap;

export const API_MAP: ApiMapType = new Proxy({} as ApiMapType, {
  get: function(target, prop: string) {
    const map = isTagProxyEnabled() ? TagApiMap : ApigeeApiMap;
    if (prop in map) {
      return map[prop as keyof typeof map];
    }
    console.error('Property ' + prop + ' not found in the selected API_MAP.');
  }
});